import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { HTMLAttributes } from 'react';
import VoxelIconButton from '../Buttons/VoxelIconButton';

export interface VoxelTablePaginationProps
  extends Pick<HTMLAttributes<HTMLTableRowElement>, 'onClick'> {
  colSpan: number;
  className?: string;
  currentPage: number;
  totalCount: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
  align?: 'left' | 'right';
  size?: 'sm' | 'md' | 'lg';
}

export const VoxelTablePagination: React.FC<VoxelTablePaginationProps> = ({
  children,
  colSpan,
  onClick,
  currentPage,
  totalCount,
  className,
  rowsPerPage,
  onPageChange,
  align = 'right',
  size = 'md',
  ...divProps
}) => {
  const totalPages = Math.ceil(totalCount / rowsPerPage);
  const firstItemNr = rowsPerPage * currentPage + 1;

  const test = totalPages === currentPage + 1 ? totalPages * rowsPerPage - totalCount : 0;
  const lastItemNr = rowsPerPage * (currentPage + 1) - test;

  return (
    <tr className={`${className}`}>
      <td colSpan={colSpan} align={align} className={`
          ${size === 'lg' ? 'p-4' : ''}
          ${size === 'md' ? 'p-2' : ''}
          ${size === 'sm' ? 'p-1' : ''}`
      }>
        <div
          className={`flex flex-row gap-2 items-center ${align === 'right' ? 'justify-end' : 'justify-start'
            }`}
        >
          <div className="font-sans font-medium">
            {firstItemNr}-{lastItemNr} of {totalCount}
          </div>
          <VoxelIconButton
            color="white"
            size="lg"
            icon={<FontAwesomeIcon icon={faChevronLeft} />}
            onClick={(event) => onPageChange(event, currentPage - 1)}
            disabled={currentPage === 0}
          />
          <VoxelIconButton
            color="white"
            size="lg"
            icon={<FontAwesomeIcon icon={faChevronRight} />}
            onClick={(event) => onPageChange(event, currentPage + 1)}
            disabled={currentPage >= totalPages - 1}
          />
        </div>
      </td>
    </tr >
  );
};

export default VoxelTablePagination;
